import { LadzoConsole as Lc } from "../global/ladzo-console.js";
import * as scroll from "./scrollWatcher.js";

function zavriNavigaciKliknutimMimo() {
  $(document).on("click", function (e) {
    const $menu = $("#dvMenu");
    const $button = $("#aMenu");

    // Pokud klik není ani na menu, ani na tlačítko
    if (
      !$menu.is(e.target) &&
      $menu.has(e.target).length === 0 &&
      !$button.is(e.target) &&
      $button.has(e.target).length === 0
    ) {
      // Odebere třídy pro otevřené menu
      $("body").removeClass("bdNavig");
    }
  });
}

export function zobrazNavigaci() {
  Lc.f("zobrazNavigaci");
  //$("body").addClass("bdNavig");
  $("#aMenu").on("click", function (e) {
    e.preventDefault(); // zabrání přechodu na jinou stránku
    //$("body").toggleClass("bdNavig");
    $("html").toggleClass("htmlNavig");

    // Po přepnutí třídy zjistíme, zda navigace JE nebo NENÍ otevřená
    const isNavigOpen = $("body").hasClass("bdNavig");

    if (!isNavigOpen) {
      // Navigace byla zavřena, chceme scrollovat nahoru
      scroll.scrollToTop();
    }
  });
  zavriNavigaciKliknutimMimo();
}
